import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HrFlexContainer, HrInputText, HrPrimary } from '@components/styles/hr-styles';

const FilterContainer = styled(HrFlexContainer)`
  justify-content: space-between;
  flex-wrap: nowrap;
`;

const Input = styled(HrFlexContainer)`
  max-width: 320px;
  justify-content: flex-start;
  position: relative;
  flex-wrap: nowrap;

  & span {
    position: absolute;
    right: 12px;
    color: ${HrPrimary};
    font-size: 16px;
    cursor: pointer;
  }
`;

const handleKeyDown = (event, inputFilter) => {
  if (event.key === 'Enter') {
    inputFilter(event);
  }
};

const handleInput = (event, inputFilter) => {
  if (
    event.nativeEvent.inputType === 'deleteContentBackward' ||
    event.nativeEvent.inputType === 'deleteContentForward'
  ) {
    return;
  }
  if (event.target.value === '') {
    inputFilter({ target: { value: '' } });
  }
};

const handleIconClick = (inputRef, inputFilter) => {
  if (inputRef.current) {
    inputFilter({ target: { value: inputRef.current.value } });
  }
};

export const Filter = ({ placeholder, inputFilter, rows, total, filterText }) => {
  const inputRef = useRef(null);

  return (
    <FilterContainer>
      <Input>
        <HrInputText
          ref={inputRef}
          id='search'
          name='search'
          type='search'
          padding='0 32px 0 16px'
          placeholder={placeholder}
          onKeyDown={(e) => handleKeyDown(e, inputFilter)}
          onInput={(e) => handleInput(e, inputFilter, inputRef)}
        />
        <span
          className='hr-Search'
          onClick={() => handleIconClick(inputRef, inputFilter)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleIconClick(inputRef, inputFilter);
          }}
          role='button'
          tabIndex={0}
          aria-label='Search'
        />
      </Input>
      <p>
        {rows.length}/{total} {filterText}
      </p>
    </FilterContainer>
  );
};

Filter.propTypes = {
  placeholder: PropTypes.string,
  inputFilter: PropTypes.func,
  rows: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
  filterText: PropTypes.string
};

Filter.defaultProps = {
  placeholder: 'Buscar...',
  inputFilter: () => {},
  rows: [],
  total: 0,
  filterText: 'resultados'
};
